import { Injectable, inject } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DsmApiCall } from './dsm-api-call.service';
import { CommentDto, SupportedAggregateTypes } from '../models/comment.model';
import { DsmApiResponseDataDto } from '../models/dsm-api-call.model';

@Injectable({ providedIn: 'root' })
export class CommentService {
  private serviceCall = inject(DsmApiCall);

  loadComments(aggregateId: string, aggregateType: SupportedAggregateTypes, limit: number, offset: number): Observable<DsmApiResponseDataDto> {
    const url: string =
      environment.apiBaseUrl + '/commons/comments/v2/' + aggregateType?.toString() + '/' + aggregateId + '?limit=' + limit + '&offset=' + offset;
    return this.serviceCall.get(url).pipe(
      map(resp => {
        return resp.body;
      })
    );
  }

  addComment(comment: CommentDto): Observable<DsmApiResponseDataDto> {
    if (!comment?.referencedAggregateId || !comment?.referencedAggregateType) return of(null);

    const url: string =
      environment.apiBaseUrl + '/commons/comments/v2/' + comment?.referencedAggregateType?.toString() + '/' + comment?.referencedAggregateId;
    return this.serviceCall.post(url, comment).pipe(
      map(resp => {
        return resp.body;
      })
    );
  }

  updateComment(comment: CommentDto): Observable<DsmApiResponseDataDto> {
    if (!comment?.referencedAggregateId || !comment?.referencedAggregateType) return of(null);

    const url: string =
      environment.apiBaseUrl +
      '/commons/comments/v2/' +
      comment?.referencedAggregateType?.toString() +
      '/' +
      comment?.referencedAggregateId +
      '/' +
      comment?.aggregateId;
    return this.serviceCall.put(url, comment).pipe(
      map(resp => {
        return resp.body;
      })
    );
  }

  deleteComment(
    referencedAggregateType: SupportedAggregateTypes,
    referencedAggregateId: string,
    aggregateId: string
  ): Observable<DsmApiResponseDataDto> {
    const url: string =
      environment.apiBaseUrl + '/commons/comments/v2/' + referencedAggregateType?.toString() + '/' + referencedAggregateId + '/' + aggregateId;
    return this.serviceCall.delete(url).pipe(
      map(resp => {
        return resp.body;
      })
    );
  }
}
